import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ContactCta() {
  const { t } = useTranslation();
  return (
    <section className="contact-cta">
      <div className="container">
        <div className="contact-cta-inner">
          <div className="contact-cta-text">
            <h2>{t('contactCta.title')}</h2>
            <p>{t('contactCta.description')}</p>
          </div>
          <Link to="/contact" className="btn-default">{t('contactCta.cta')}</Link>
        </div>
      </div>
    </section>
  );
}
